import React from 'react';
import { useAtom } from 'jotai';
import { Card, CardBody, Table } from '@statsbomb/kitbag-components';
import { FormattedMessage, useIntl } from 'react-intl';
import CardHeader from '../CardHeader';
import CellHeadings from '../CellHeadings';
import { uploadsInProgressAtom } from '../../atoms/uploads';
import { FILE_CHUNK_SIZE } from '../Ingest/Ingest';

export function UploadStatus() {
  const intl = useIntl();

  const [uploadsInProgress] = useAtom(uploadsInProgressAtom);

  const uploadsInProgressCount = uploadsInProgress.uploads.length;

  const uploadPercentage = (upload) =>
    Math.round(((upload.complete * FILE_CHUNK_SIZE) / upload.size) * 100);

  const progressStatus = (upload) =>
    intl.formatMessage(
      {
        defaultMessage: '{uploadPercentage}%',
        id: '4f236',
      },
      {
        uploadPercentage: uploadPercentage(upload),
      },
    );

  const byFilename = (a, b) => a.filename.localeCompare(b.filename);
  const sortedUploads = uploadsInProgress.uploads.sort(byFilename);

  return (
    <Card>
      <CardHeader>
        <FormattedMessage defaultMessage="Uploads From File" id="3e7d7" />
      </CardHeader>
      <CardBody>
        <Table stickyColumns={0}>
          <CellHeadings
            cells={[
              {
                children: intl.formatMessage({
                  defaultMessage: 'Filename',
                  id: '13510',
                }),
                id: 'Destination',
              },
              {
                children: intl.formatMessage({
                  defaultMessage: 'Status',
                  description: 'Status',
                  id: 'dc56e',
                }),
                id: 'Status',
              },
            ]}
            textAlign="left"
          />
          <Table.Body>
            {uploadsInProgressCount > 0 ? (
              sortedUploads.map((upload) => (
                <Table.Row key={upload.filename}>
                  <Table.DataCell $textAlign="left">
                    {upload.filename}
                  </Table.DataCell>
                  <Table.DataCell $textAlign="left">
                    {upload.message}
                    {uploadPercentage(upload) < 100 &&
                      ` (${progressStatus(upload)})`}
                  </Table.DataCell>
                </Table.Row>
              ))
            ) : (
              <Table.Row key="table-row-empty-listing">
                <Table.DataCell $textAlign="left" colSpan={3}>
                  <FormattedMessage
                    defaultMessage="Upload progress will appear here"
                    id="321e0"
                  />
                </Table.DataCell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </CardBody>
    </Card>
  );
}

export default UploadStatus;
